<template>
    <div id="centerRight1">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
                <div class="d-flex">
                    <span class="fs-xl text mx-2">健康档案人数</span>
                </div>
            </div>
            <div class="d-flex jc-center body-box">
                <dv-capsule-chart class="dv-cap-chart" :config="config"/>
            </div>
        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';

    export default {
        data() {
            return {
                config: {
                    data: [],
                    unit: '人',
                    showValue: true
                }
            }
        },
        components: {},
        mounted() {
        },
        methods: {},
        created() {
            let area = this.$route.query.area;
            let code = this.$route.query.code;
            let level = this.$route.query.level;
            var data = {}
            if (level == '2') {
                data = {area: area}
            } else {
                data = {code: code}
            }
            request({
                url: this.$root.api + `/api/dbz/daping/getJcszOrJkdaList/jkdars`,
                method: 'get',
                data: data
            }).then(res => {
                console.log('jkdars---健康档案', res)
                let resdata = res.data;
                // let resdata=[["昌乐县","69228"],["安丘市","87775"],["滨海","5082"],["昌邑市","65138"],["坊子区","32283"],["高密市","96519"],["高新区","20598"],["寒亭区","43743"],["奎文区","40120"],["临朐县","88268"],["青州市","94352"],["寿光市","140527"],["潍城区","49680"],["潍坊市直","0"],["峡山区","21517"],["诸城市","111556"]]
                let cdata = this.config;
                resdata.forEach(child => {
                    let obj = {};
                    obj.name = child[0]
                    obj.value = child[1]
                    cdata.data.push(obj)
                });
                this.config = {...cdata}
                console.log('jkdars---config', this.config)
            })
        },
    }
</script>

<style lang="scss" scoped>
    #centerRight1 {
        padding: 16px;
        padding-top: 20px;
        height: 500px;
        width: 100%;
        border-radius: 5px;

        .bg-color-black {
            height: 480px;
            border-radius: 10px;
        }

        .text {
            color: #c3cbde;
        }

        .body-box {
            border-radius: 10px;
            overflow: hidden;

            .dv-cap-chart {
                width: 100%;
                height: 440px;
            }
        }
    }
    ::v-deep.dv-capsule-chart {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 5px;
        color: #fff;
    }
    ::v-deep.dv-capsule-chart .label-column {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding-right: 5px;
        text-align: right;
        font-size: 12px;
    }

    ::v-deep.dv-capsule-chart .capsule-item .capsule-item-column .capsule-item-value {
        font-size: 12px;
        -webkit-transform: translateX(0%);
        transform: translateX(0%);
    }
    ::v-deep.dv-capsule-chart .capsule-item .capsule-item-column {
        position: relative;
        height: 8px;
        margin-top: 1px;
        border-radius: 5px;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: end;
        -ms-flex-pack: end;
        justify-content:flex-start;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
</style>
 